import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import * as DESUI from "react-bootstrap"; import Menubar from "../Menubar";
import { store } from "../../App"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import autoTable from "jspdf-autotable"; import { Modal, Row, Col, Container } from "react-bootstrap";
import KpiService from "../../Services/KpiService"; import { Button } from "reactstrap"; import { FaRegSave } from "react-icons/fa";
 import useAlert from "../Alert/useAlert"; import AlertModal from "../Alert/AlertModal";
import allowNumbersOnly, { exportToentryExcel,  generateentryPdf, restrictToPasteOnlyMobileNumber } from "../utils/commonFunctions";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import Select from 'react-select';
import { RiEdit2Fill } from "react-icons/ri";
export default function HodDesLevelDistrictMapOfficers() {
  
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();

  const [distlist, setDistlist] = useState([]); const [ddolist, setDdolist] = useState({}); const [orglist, setorglist] = useState({});
  const [data, setData] = useState(); const [Empdata, setEmpdata] = useState([]); const [distEnb, setDistEnb] = useState(true); const [addModal, setAddModal] = useState(); const [searchText, setSearchText] = useState("");
  const [searchText1, setSearchText1] = useState("");
   const [empmaplist, setEmpmaplist] = useState({});const [emplist, setEmplist] = useState({}); const [employeegetdata, setEmployeegetdata] = useState([]); const [EditEmpdata, setEditEmpdata] = useState([]); const[selecteddist,setSelecteddist] = useState(); const [Index, setIndex] = useState([]);
  let roleid = localStorage.getItem("role");let username = localStorage.getItem("username");   let deptid =localStorage.getItem("deptid");
  //  let district = localStorage.getItem("districtid"); const [upd_orglist, setupd_orglist] = useState();
  const [editenb, setEditenb] = useState(false); const [activeTab, setActiveTab] = useState("");

  const formik = useFormik({
    initialValues: {
      district_id: "", 
      list:[{user_id:"",org_id: "", ddo_code: "",emp_id:"",districtId:"",cfmsid:"",fieldenb:false,ddocode_description:"",employee_name:"",org_name:"",alternate_mobile_no:""
      }] ,
      upd_ddo:"",upd_org:"",upd_emp:"",upd_alternate_mobile_no:"", edit_mobile:""
    },

  })

  React.useEffect(() => {
    if ((roleid === "2") || (roleid === "10") || (roleid === "3")) {
      setDistEnb(true)

    }
    if (roleid === "5") {
      setDistEnb(false)
    formik.setFieldValue("district_id", "0");

    }

    
    
  }, [])

const getemployeeData = () => {
  const clearedList = formik.values.list.map((item) => ({
    ...item,
    ddo_code: "",
    org_id: "",
    emp_id: "",
  }));
  formik.setFieldValue('list', clearedList);

  let payload = {
    userId: username,
    distId: "0",
    buttonType: "get",
  };

  KpiService.getusersDistList(payload)
    .then((res) => {
      if (res?.data?.SCODE === "01") {
        setEmpdata(res.data.SDESC);
        const data = res.data.SDESC;
        const updatedRows = data.map((item) => ({
          user_id: item.userid,
          org_id: "",
          ddo_code: "",
          emp_id: "",
          districtId: item.district_id,
          cfmsid: "",
          fieldenb: false,
          ddocode_description: "",
          org_name: "",
          employee_name: "",
          alternate_mobile_no: "",
        }));
        formik.setFieldValue('list', updatedRows);

        KpiService.getHodDesLevelDistrictMapOfficers(payload)
          .then((response) => {
            if (response?.data?.SCODE === "01") {
              setEmployeegetdata(response.data.dataList);

              const matchedRows = data.map((descItem) => {
                const match = response.data.dataList.find(
                  (respItem) => respItem.user_id === descItem.userid
                );
                return match
                  ? {
                      user_id: match.user_id,
                      ddo_code: match.ddocode,
                      org_id: match.org_id,
                      emp_id: match.cfmsid,
                      cfmsid: match.cfmsid,
                      ddocode_description: match.ddocode_description,
                      org_name: match.org_name,
                      employee_name: match.emp_name,
                      alternate_mobile_no: match.alternate_mobile_no,
                      districtId: descItem.district_id,
                      fieldenb: true, // Already has data, so lock it
                    }
                  : { ...updatedRows[data.indexOf(descItem)] }; // Unmatched: keep as is
              });

              formik.setFieldValue('list', matchedRows);

              // Defer MandalDdoData calls to avoid synchronous state updates during loop
              setTimeout(() => {
                matchedRows.forEach((row, index) => {
                  if (!row.ddo_code || row.ddo_code.trim() === "") {
                    MandalDdoData(row.districtId, index);
                    formik.setFieldValue(`list[${index}].fieldenb`, false);
                  }
                });
              }, 0);
            }
          })
          .catch((error) => {
            console.error("Error fetching HodDesLevelDistrictMapOfficers:", error);
            showAlertMessage("Error fetching mapping data. Please try again.", "warning");
          });
      } else {
        const message = res?.data?.SDESC || "Unexpected response format.";
        console.warn("API Response Issue:", message, res?.data);
        showAlertMessage(message, "warning");
      }
    })
    .catch((error) => {
      console.error("Error fetching usersDistList:", error);
      showAlertMessage("Error fetching data. Please try again.", "warning");
    });
};
  
// const getemployeeData = () => {
//   const payload = {
//     userId: username,
//     distId: "0",
//     buttonType: "get",
//   };

//   KpiService.getusersDistList(payload)
//     .then((res) => {
//       if (res?.data?.SCODE === "01") {
//         setEmpdata(res.data.SDESC);
//         const data = res.data.SDESC;

//         const updatedRows = data.map((item) => ({
//           user_id: item.userid,
//           org_id: "",
//           ddo_code: "",
//           emp_id: "",
//           districtId: item.district_id,
//           cfmsid: "",
//           fieldenb: false,
//           ddocode_description: "",
//           org_name: "",
//           employee_name: "",
//           alternate_mobile_no: "",
//         }));

//         formik.setFieldValue("list", updatedRows);

//         KpiService.getHodDesLevelDistrictMapOfficers(payload).then((response) => {
//           if (response?.data?.SCODE === "01") {
//             setEmployeegetdata(response.data.dataList);

//             const matchedRows = data.map((descItem, index) => {
//               const match = response.data.dataList.find(
//                 (respItem) => respItem.user_id === descItem.userid
//               );

//               return match
//                 ? {
//                     user_id: match.user_id,
//                     ddo_code: match.ddocode,
//                     org_id: match.org_id,
//                     emp_id: match.cfmsid,
//                     cfmsid: match.cfmsid,
//                     ddocode_description: match.ddocode_description,
//                     org_name: match.org_name,
//                     employee_name: match.emp_name,
//                     alternate_mobile_no: match.alternate_mobile_no,
//                     districtId: descItem.district_id,
//                     fieldenb: true, // ✅ already has data, lock it
//                   }
//                 : { ...updatedRows[index] }; // unmatched — fieldenb: false
//             });

//             // ✅ Single update for the whole list
//             formik.setFieldValue("list", matchedRows);

//             // ✅ Call MandalDdoData AFTER state settles, only for unmatched rows
//             setTimeout(() => {
//               matchedRows.forEach((row, index) => {
//                 console.log(`ddocode =`, row.ddo_code);
//                 if (!row.ddo_code || row.ddo_code.trim() === "") {
//                 console.log(`districtId =`, row.districtId);
//                   MandalDdoData(row.districtId, index);
//                 }
//               });
//             }, 0);
//           }
//         });
//       } else {
//         const message = res?.data?.SDESC || "Unexpected response format.";
//         showAlertMessage(message, "warning");
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching data:", error);
//       showAlertMessage("Error fetching data. Please try again.", "warning");
//     });
// };
 const geteditemployeeData = (detail,index) => {
  console.log("detail",detail);
  setEditenb(true);
  setIndex(index);
  console.log("index",index);
  // formik.values.list.map((item,index)=>{
  // formik.setFieldValue(`list.[${index}].ddo_code`, ""); 
  // formik.setFieldValue(`list.[${index}].org_id`, ""); 
  // formik.setFieldValue(`list.[${index}].emp_id`, "");
  // })
    let payload = {
      "deptId": deptid,
        "userId": detail.userid,
        "distId": detail.district_id,
        "mandalId":"0",
        "buttonType": "get"
    };
 store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getupdateEmpMappingDetails(payload)
    .then((res) => {
        if (res?.data?.SCODE === "01") {

            setEditEmpdata(res.data.dataList[0]);
            const data=res.data.dataList[0];
// console.log("detail.dist_id",data.dist_id);
           MandalDdoData(data.dist_id,index);
            // formik.setFieldValue(`list[${index}].ddo_code`,data.ddocode);
          //  MandalOrgData(data.ddocode,index);
            // formik.setFieldValue(`list[${index}].org_id`,data.org_id);
            //  EmployeeDetails(data.org_id,index);
            // formik.setFieldValue(`list[${index}].emp_id`,parseInt(data.cfmsid))
            // formik.setFieldValue(`list[${index}].alternate_mobile_no`,data.alternate_mobile_no);

            formik.setFieldValue(`list[${index}].ddo_code`,""); formik.setFieldValue(`list[${index}].org_id`,""); formik.setFieldValue(`list[${index}].emp_id`,""); formik.setFieldValue(`list[${index}].alternate_mobile_no`,""); setAddModal(true);
          
          } else { const message = res?.data?.SDESC || "Unexpected response format."; console.warn("API Response Issue:", message, res?.data); showAlertMessage(message, "warning"); }
        }).catch((error) => { console.error("Error fetching data:", error); showAlertMessage("Error fetching data. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
};
  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" }); MasterService.getDistricts().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistlist(options); } });
    if(roleid === "5"){ getemployeeData() } store.dispatch({ type: "HIDE_SPINNER" });
  }, []);

//   const MandalDdoData = (district,index) => {
//       {!editenb &&formik.setFieldValue(`list.[${index}].ddo_code`, ""); 
//     formik.setFieldValue(`list.[${index}].org_id`, ""); 
//     formik.setFieldValue(`list.[${index}].emp_id`, ""); }
    
//     if(!district){return;}
// setSelecteddist(district);
//     setDdolist([])
//     store.dispatch({ type: "SHOW_SPINNER" });
//     // formik.setFieldValue("ddo_code", "")
 
//     let params = { "deptId": localStorage.getItem("deptid"), "distCode": parseInt(district), "userId":username, }
//     KpiService.getDdolist(params).then((res) => {
     
//     store.dispatch({ type: "HIDE_SPINNER" });

//       if (res.data.SCODE == "01") {
//         let options = res.data?.SDESC.map((item, i) => {
//           return (
//             <option key={i} value={item.ddocode}> {item.ddocode_description} </option>
//           );
//         });
//         console.log("options",options);
//         // setDdolist(options);
//         setDdolist((prev) => ({ ...prev, [index]: res.data?.SDESC })); 

//       }
//     });
//   }
const MandalDdoData = (district, index) => {
  if (!editenb) {
    formik.setFieldValue(`list[${index}].ddo_code`, "");
    formik.setFieldValue(`list[${index}].org_id`, "");
    formik.setFieldValue(`list[${index}].emp_id`, "");
  }

  if (!district) return;

  setSelecteddist(district);
  // ✅ Don't reset to [] — keep it as object
  setDdolist((prev) => ({ ...prev, [index]: [] }));
  store.dispatch({ type: "SHOW_SPINNER" });

  let params = {
    deptId: localStorage.getItem("deptid"),
    distCode: parseInt(district),
    userId: username,
  };

  KpiService.getDdolist(params).then((res) => {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (res.data.SCODE == "01") {
      setDdolist((prev) => ({ ...prev, [index]: res.data?.SDESC }));
    }
  });
};
  //  const MandalupdatedDdoData = (district) => {
  //      formik.setFieldValue("upd_ddo", ""); 
  //   formik.setFieldValue("upd_org", ""); 
  //   formik.setFieldValue("upd_emp", ""); 
  //   if(!district){return;}
  //   setDdolist([])
  //   store.dispatch({ type: "SHOW_SPINNER" });

 
  //   let params = { "deptId": localStorage.getItem("deptid"), "distCode": parseInt(district), "userId":username, }
  //   KpiService.getDdolist(params).then((res) => {
  //   store.dispatch({ type: "HIDE_SPINNER" });

  //     if (res.data.SCODE == "01") {
  //       let options = res.data?.SDESC.map((item, i) => {
  //         return (
  //           <option key={i} value={item.ddocode}> {item.ddocode_description} </option>
  //         );
  //       });
  //       console.log("options",options);
  //       // setDdolist(options);
  //       setDdolist(res.data?.SDESC); 

  //     }
  //   });
  // }

  // const MandalUpdatedOrgData = (val) => {
   
  //   formik.setFieldValue("upd_org", ""); 
  //   formik.setFieldValue("upd_emp", ""); 
  //   setupd_orglist([]); 
  // if(val===""){
  //   return;
  // }
  //   // const selectedDdoCode = e.target.value;
   
  
  //   let params = {
  //     ddoCode: val,
  //     userId: username,
  //   };
  
  //   store.dispatch({ type: "SHOW_SPINNER" });
  
  //   KpiService.getOrglist(params)
  //     .then((res) => {
  //       if (res.data.SCODE == "01") {
  //         let options = res.data.SDESC.map((item, i) => (
  //           <option key={i} value={item.org_id}>
  //             {item.org_name}
  //           </option>
  //         ));
  //         console.log("Updated orglist:", { ...orglist, [index]: options });
  
  //         setorglist(res.data.SDESC ); 
  //       }
  //     })
  //     .finally(() => {
  //       store.dispatch({ type: "HIDE_SPINNER" });
  //     });
  // };
const MandalOrgData = (val, index) => {
  if (!val) {
    setorglist((prev) => ({ ...prev, [index]: [] }));
    return;
  }

  // ✅ Reset ONLY when needed
  formik.setFieldValue(`list.[${index}].org_id`, "");
  formik.setFieldValue(`list.[${index}].emp_id`, "");

  let params = {
    ddoCode: val,
    userId: username,
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.getOrglist(params) .then((res) => { if (res.data.SCODE === "01") { setorglist((prev) => ({ ...prev, [index]: res.data.SDESC, })); } }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
};
 const EmployeeDetails = (val,index) => { if(val===""){ return; }
    let params = {  "orgId": val }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getemployees(params).then((res)=>{
      store.dispatch({ type: "HIDE_SPINNER" });
      if (res.data && res.data.SCODE === "01") { let options = res.data.EMP_DATA?.map((item, i) => ( <option key={i} value={item.cfms_id}> {item.emp_name} </option> )); setEmplist((prev) => ({ ...prev, [index]: res.data.EMP_DATA })); } else{ setEmplist(prev => ({ ...prev, [index]: [] })); }
    
}).catch((error) => { console.error("Error saving data:", error); showAlertMessage("No data.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) }); }


  const getEmployeeMapdata = (ord_id, empid, i) => {if(!ord_id || empid ===""){return;}

    let params = { orgId: ord_id }; KpiService.getEmplist(params) .then((res) => { if (res?.data?.SCODE === "01") { res.data.EMP_DATA?.forEach((item) => { if (item.cfms_id == empid) { setEmpmaplist((prev) => ({ ...prev, [i]: item })); } }); } else { const message = res?.data?.SDESC || "Unexpected response format."; console.warn("API Response Issue:", message, res?.data); showAlertMessage(message, "warning"); } })
      .catch((error) => { console.error("Error fetching data:", error); showAlertMessage("Error fetching data. Please try again.", "warning"); });
  };
  

  const searchColumns = ["position_name", "name", "cfms_id", "mobileno","employeeid","dob","gender_desc"]; const normalSearchText = searchText.trim().toLowerCase();
  // const filteredData = normalSearchText.length > 0 && data?.length ? data.filter((item) => { return ( item && searchColumns.some((key) => { const value = item[key]; return ( value !== null && value !== undefined && value.toString().toLowerCase().includes(normalSearchText) ); }) );}): data;
  
  const filteredDataa = searchText1.length > 0 && Empdata?.length ? Empdata.filter((item) => { return(item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()) ); }) ); }) : Empdata;
  const [selectedIndex, setSelectedIndex] = useState(null);

  function validateMobileNumber(mobile) { if(!mobile){ return; } const mobileRegex = /^[6-9]\d{9}$/; if (!mobileRegex.test(mobile)) { showAlertMessage("Invalid mobile number! It should start with 6-9 and be 10 digits long.","warning"); return false; } return true; }

// const handleCheckboxChange = (index) => { if (selectedIndex === index) { setSelectedIndex(null); } else { setSelectedIndex(index); } }

const handleClose = () => {
  setAddModal(false);
  setEditenb(false);
  setActiveTab("");
  formik.setFieldValue("edit_mobile", "");
};

const changemobile = () => {
  if (!validateMobileNumber(formik.values.edit_mobile)) {
    return;
  }

  const payload = {
    hodId: localStorage.getItem("hod_id"),
    ulbId: "0",
    deptId: deptid,
    orgId: EditEmpdata?.org_id,
    positionId: EditEmpdata?.position_id,
    ddoCode: EditEmpdata?.ddocode,
    cfmsId: EditEmpdata?.cfmsid,
    distId: EditEmpdata?.dist_id,
    mandalId: "0",
    dateOfBirth: EditEmpdata?.date_of_birth,
    mobileNumber: EditEmpdata?.mobile_number,
    alternateMobileNo: formik.values.edit_mobile,
    mobileNumbers: [EditEmpdata?.mobile_number, formik.values.edit_mobile],
    gender: EditEmpdata?.gender,
    empName: EditEmpdata?.emp_name,
    empId: EditEmpdata?.emp_id,
    userId: username,
  };

  store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.editEmpMobileNo(payload)
    .then((res) => {
      if (res.data) {
        showAlertMessage(res.data.SDESC, res.data.SCODE === "01" ? "success" : "warning", () => {
          if (res.data.SCODE === "01") {
            getemployeeData();
          }
        });
      }
    })
    .catch((error) => {
      console.error("Error updating mobile number:", error);
      showAlertMessage("Failed to update mobile number.", "warning");
    })
    .finally(() => {
      formik.setFieldValue("edit_mobile", "");
      setActiveTab("");
      setAddModal(false);
      setEditenb(false);
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};


const SaveData = (emp,mobile,i,dist) => {

  let missingFields = [];
    if (!formik.values.list[i].ddo_code) missingFields.push("DDO Code");
    if (!formik.values.list[i].org_id) missingFields.push("Organization Id");
    if (!formik.values.list[i].emp_id) missingFields.push("Employee Id")
 
      if(missingFields.length > 0){
        const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
        showAlertMessage(errorMessage, "warning");
        return;
        }
       validateMobileNumber(formik.values.list[i].alternate_mobile_no);
       if (editenb) {
  if (!formik.values.list[i].alternate_mobile_no) { 
     showAlertMessage("Please Enter Alternate Mobile Number", "warning");
     return;
      }
    }
  const payload = {
    userId:username,
// ...editenb ?{ userId:formik.values.list[i].user_id,}:{ userId:username},

    distId:dist,
   ...editenb ?{deptId:deptid}:{},
  buttonType:"save",
    //  mandalId:detail.mandal_id,
  ddoCode:emp.ddocode,
   orgId:emp.org_id,
    cfmsId:emp.cfms_id,
    positionId:emp.position_id,
    mobileNumber:emp.mobileno,
   empId:emp.employeeid,
    gender:emp.gender_desc,
   empName:emp.name,
   alternateMobileNo:mobile,
   mobileNumbers:[emp.mobileno,mobile],
   mandalId:"0",
   rollId: editenb? "5":"2",
   ulbId:"0"
  };
  console.log("pay",payload)
  store.dispatch({ type: "SHOW_SPINNER" });
  const serviceCall = editenb
    ? KpiService.updateEmpMappingDetails(payload)
    : KpiService.getHodDesLevelDistrictMapOfficers(payload);
 serviceCall.then((res)=>{
      if(res.data) {
        showAlertMessage(res.data.SDESC,res.data.SCODE==="01"? "success":"warning" ,  () => {
          formik.values.list?.forEach(index=>{
            setorglist((prev) => ({ ...prev, [index]: [] })); 
            setEmplist((prev) => ({ ...prev, [index]: [] })); 
          })
         {res.data.SCODE==="01" && getemployeeData()}

            // getemployeeData();setAddModal(false);
            // formik.setValues(prevValues => ({
            //   ...Object.keys(prevValues).reduce((acc, key) => {
            //     acc[key] = key === 'district_id' ? prevValues[key] : '';
            //     return acc;
            //   }, {})
            // }));setorglist([]);setSelectedIndex(null);

          })
      }}).catch((error) => {
        console.error("Error saving data:", error);
        showAlertMessage("Failed to save data.", "warning");
      }).finally(() => {
        setAddModal(false);
  setEditenb(false);
    store.dispatch({ type: "HIDE_SPINNER" });
  });
  }


return (
  <>
    <Menubar />
    <Container fluid  style={{width:"95%"}}className='map-header'>
      <div className='sa-title'>
        <h2>District Employee  <span> Mapping</span></h2>
      </div>
    </Container>

    <DESUI.Container fluid className="outer-page-content-container" style={{width:"95%", height: "1100px", overflow: "visible" }} >
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>

          <div className='mandal-container p-4 mt-2'>

            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="district_id" disabled={true} className="form-control" 
                 > 
                <option value="">--Select--</option> <option value="0">All</option> {distlist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
              </Col>

              {/* <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                <label className="mb-1 fw-bold">MANDAL</label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="mandal_id" className="form-control" onChange={(e) => {formik.setFieldValue("org_id","");formik.handleChange(e) }} > <option value="">--Select--</option> {mandallist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="mandal_id" /> </span>
              </Col> */}

              {/* <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                <label className="mb-1 fw-bold"> DDO NAME </label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="ddo_code" className="form-control" onChange={(e) => { MandalOrgData(e); formik.handleChange(e) }} > <option value="">--Select--</option> {ddolist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="ddo_code" /> </span>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                <label className="mb-1 fw-bold"> ORGANIZATION NAME </label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="org_id" className="form-control" onChange={(e) => { EmployeeData(e); }} > <option value="">--Select--</option> {orglist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="org_id" /> </span>
              </Col> */}
            </Row>
          </div>
        <br />
     

      <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "200px", minWidth: "200px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }}
                onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "200px"; }} >
                <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", visibility: "visible", color: "#888" }} />
                <input type="text" value={searchText1} placeholder="Search "  onChange={(event) => setSearchText1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
              </div>
            </Col>
             <Col className=" mb-2 " >
                                                  <button className="btn btn-danger btn-sm mx-2 pdf-btn" style={{ float: "right", marginLeft: "3px" }} type="button" onClick={()=>generateentryPdf("my-table",formik.values,"HodDistrictMappedUserdetails")} > PDF <MdOutlinePictureAsPdf /> </button>
                                                  <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} type="button" onClick={() => exportToentryExcel("my-table", formik.values,"HodDistrictMappedUserdetails")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                                              </Col>
          </Row>
             <div id="table-scroll"  style={{ maxHeight: '600px', overflowX: 'hidden', overflowY: 'auto' }} >
          <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" ><thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                
                <tr className="text-center">
                <th colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}><span style={{color: "orange" }}>Hod District Mapped User Details </span> </th></tr>

                <tr className="text-center">
                  <th  > Sl No. </th> 
                  {/* <th  >Cfms Id </th>  */}
                   <th  > User Id </th> <th  > District  </th>
                  {/* <th  > Position Id-Designation  </th>
                 
                  <th  >Employee Name   </th> 
                
                    <th  > Mobile  </th> */}
                  <th style={{width:"20%" }} >DDO Name   </th> <th  > Organization Name </th> <th  > Employee Name </th> <th  > Alternate Mobile Number</th> <th  > Map District Officers </th>
                 
                </tr>
              </thead>
              <tbody>
                {filteredDataa?.length === 0 || filteredDataa?.length === undefined ? ( <tr> <td className="text-center" colSpan="8"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr> ) : (
                  filteredDataa.map((detail, i) => {
                    const actualIndex = Empdata.findIndex((emp) => emp.userid === detail.userid);

      return (
                        <tr key={i}><td style={{ textAlign: "center" }}>{i + 1}</td> 
                          {/* <td style={{ textAlign: "left" }}>{detail.cfmsid ? detail.cfmsid : ""}</td> */}
                          <td style={{ textAlign: "left" }}>{detail.userid}</td> <td style={{ textAlign: "left" }}>{detail.district_name}</td>
                       
                          <td style={{ textAlign: "left" }}> {formik.values.list[actualIndex].ddocode_description ?<Field type="text" name={`list.[${actualIndex}].ddocode_description`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb} />:
     
     
      // <Field component="select" name={`list.[${actualIndex}].ddo_code`} className="form-control"  onChange={(e) => { MandalOrgData(e.target.value,actualIndex); formik.handleChange(e) }}         
      //   > <option value="">--Select--</option> 
      // {ddolist[actualIndex] ? ddolist[actualIndex] : []}
      // </Field>}
   <Select className="w-100 fw-bold" isClearable isSearchable name={`list.[${actualIndex}].ddo_code`} required getOptionValue={(option) => option.ddocode} getOptionLabel={(option) => option.ddocode_description} options={ddolist?.[actualIndex] || []} style={{ fontSize: "17px" }} value={ ddolist?.[actualIndex]?.find( (option) => option.ddocode === formik.values.list?.[actualIndex]?.ddo_code ) || null }

  onChange={(option) => { const newValue = option ? option.ddocode : ""; formik.setFieldValue(`list.[${actualIndex}].ddo_code`, newValue); if (formik.values.list?.[actualIndex]?.ddo_code !== newValue) { setTimeout(() => { MandalOrgData(newValue, actualIndex); }, 0); } }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />
                                  }
     
    
                          </td>
                          <td style={{ textAlign: "left" }}>
     {formik.values.list[actualIndex].org_name ?<Field type="text" name={`list.[${actualIndex}].org_name`} 
     className="form-control"  disabled={formik.values.list[actualIndex].fieldenb}/>:
    // <Field
    //   component="select"
    //   name={`list.[${actualIndex}].org_id`}
    //   className="form-control"
    //   onChange={(e) => {
    //     EmployeeDetails(e.target.value, actualIndex);
    //     formik.handleChange(e);
    //   }}
    //   // disabled={`list.[${actualIndex}].fieldenb`}

    // >
    //   <option value="">--Select--</option>
    //   {orglist[actualIndex] ? orglist[actualIndex] : []} {/* Ensure orglist[i] is defined */}
    // </Field>}
    <Select className="w-100 fw-bold" isClearable={true} isSearchable={true} name={`list.[${actualIndex}].org_id`} required={true} getOptionValue={(option) => option.org_id} getOptionLabel={(option) => option.org_name} options={orglist[actualIndex]} value={orglist[actualIndex]?.find((option) => option.org_id === formik.values.list[actualIndex].org_id) || ""} onChange={(option) => { EmployeeDetails(option ? option.org_id : "",actualIndex); formik.setFieldValue(`list.[${actualIndex}].org_id`,option ? option.org_id : "") }} style={{ fontSize: "17px" }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />}
  </td>

  <td style={{ textAlign: "left" }}> {formik.values.list[actualIndex].employee_name ?<Field type="text" name={`list.[${actualIndex}].employee_name`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb} />:
    // <Field
    //   component="select"
    //   name={`list.[${actualIndex}].emp_id`}
    //   className="form-control"
    //   onChange={(e)=>{getEmployeeMapdata(formik.values.list[actualIndex].org_id,e.target.value, actualIndex);formik.handleChange(e)}}
    //   // disabled={`list.[${actualIndex}].fieldenb`}

    // >
    //   <option value="">--Select--</option>
    //   {emplist[actualIndex] ? emplist[actualIndex] : []} {/* Ensure emplist[i] is defined */}
    // </Field>
     <Select className="w-100 fw-bold" isClearable={true} isSearchable={true} name={`list.[${actualIndex}].emp_id`} required={true} getOptionValue={(option) => option.cfms_id} getOptionLabel={(option) => option.emp_name} options={emplist[actualIndex]} value={emplist[actualIndex]?.find((option) => option.cfms_id === formik.values.list[actualIndex].emp_id) || ""} onChange={(option) => { getEmployeeMapdata(formik.values.list[actualIndex].org_id,option ? option.cfms_id : "", actualIndex); formik.setFieldValue(`list.[${actualIndex}].emp_id`,option ? option.cfms_id : "") }} style={{ fontSize: "17px" }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />}
  </td>

  <td style={{ textAlign: "left" }}> <Field type="text" name={`list.[${actualIndex}].alternate_mobile_no`} className="form-control" onBlur={(e) => {validateMobileNumber(e.target.value);formik.handleChange(e)} } maxLength="10" onKeyPress={(e) =>{allowNumbersOnly(e)}} disabled={formik.values.list[actualIndex].fieldenb}/> </td>
  <td style={{ textAlign: "center" }}>
{!formik.values.list[actualIndex].fieldenb ?
<Button variant="" size="sm" className="map-btn" onClick={() => {console.log("i,actualIndex",i,actualIndex);SaveData(empmaplist[actualIndex],formik.values.list[actualIndex].alternate_mobile_no,actualIndex,detail.district_id)}} > Map <FaRegSave className="ms-1 s-icon" /> </Button>
:
<RiEdit2Fill style={{color:"#0f7e46",cursor:"pointer"}} size="30px"  onClick={()=>{geteditemployeeData(detail,actualIndex);}}/>
 } 
</td>
                        </tr>
                     );
                     
                    })
                  )}
              </tbody>

            </table>

          

</div>
         
             <Modal className="newmodal" size="xl" fade={false}  aria-labelledby="contained-modal-title-vcenter" centered show={addModal} >
                                            <Modal.Header style={{ justifyContent: "space-between",display: "flex",  alignItems: "center" }}>
                                                <Modal.Title style={{ margin: "0 auto" }}>Edit Employee Details</Modal.Title><button onClick={handleClose} style={{ fontSize: "29px", cursor: "pointer", background: "none", border: "none" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "black")} > &#215; </button>
                                            </Modal.Header>
                                            <Modal.Body> <FormikProvider value={formik} > <Form onSubmit={formik.handleSubmit}>
                                                        <div className='mandal-container p-4 '>
                                                                  <Row >
                                                                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                          <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Cfms Id</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.cfmsid} </p> </div>
                                                       
                                                                                                         
                                                                                                       </Col>
                                                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">District</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.district_name} </p> </div> </Col>
                                                                                                      <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">User Id</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.user_id} </p> </div> </Col>
                                                                                                      
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Position Id </label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.position_id} </p> </div> </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Designantion</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.position_name} </p> </div> </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Employee Name</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.emp_name} </p> </div> </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Mobile</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.mobile_number} </p> </div> </Col>
                                                                                                
                                                                                                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Alternate Mobile</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.alternate_mobile_no} </p> </div> </Col>
                                                                                                         <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} > <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Working Office</label> <p  style={{ color: "#6e4747" }}> {EditEmpdata.working_office} </p> </div> </Col>
                                                                                                       </Row>
                                                                                                       </div>
                                                        <div className="d-flex justify-content-left">
                                                          <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" name="employeeOption" id="editDistrictEmployeeDetails" onChange={() => setActiveTab("edit")} />
                                                            <label className="form-check-label" htmlFor="editDistrictEmployeeDetails" style={{ fontSize: "18px" }}>Edit Employee Details</label>
                                                          </div>
                                                          <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" name="employeeOption" id="changeDistrictEmployee" onChange={() => { setActiveTab("changeemp"); formik.setFieldValue("edit_mobile", ""); }} />
                                                            <label className="form-check-label" htmlFor="changeDistrictEmployee" style={{ fontSize: "18px" }}>Change Employee</label>
                                                          </div>
                                                        </div>
                                                        {activeTab === "edit" && (
                                                          <div className="rounded-2 mt-3" style={{ border: "1px solid #ccc", padding: "16px", marginBottom: "20px", position: "relative" }}>
                                                            <div style={{ position: "absolute", top: "-16px", left: "10px", backgroundColor: "white", color: "#aa1313", padding: "4px 12px", fontSize: "16px", fontWeight: "bold" }}>Edit Employee Details</div>
                                                            <Row>
                                                              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                                                                <label className="mb-1 fw-bold">Alternate Mobile</label>
                                                                <Field autoComplete="off" name="edit_mobile" className="form-control" onBlur={(e) => { validateMobileNumber(e.target.value); formik.handleChange(e); }} type="text" maxLength="10" onKeyPress={(e) => { allowNumbersOnly(e); }} {...restrictToPasteOnlyMobileNumber(formik, "edit_mobile")} />
                                                              </Col>
                                                            </Row>
                                                            <div style={{ textAlign: "center" }} className="bottom-buttons mt-1">
                                                              <Button variant="" size="sm" className="save-btn" type="button" onClick={changemobile}>Update <FaRegSave className="ms-1 s-icon" /></Button>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {activeTab === "changeemp" && <>
                                                           <Row className="mt-2 ">
                                                          <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" > <label className="mb-1 fw-bold"> DDO NAME </label> <span style={{ color: "red" }}> *</span> <Select className="w-100" isClearable={true} isSearchable={true} name={`list.[${Index}].ddo_code`} required={true} getOptionValue={(option) => option.ddocode} getOptionLabel={(option) => option.ddocode_description} options={ddolist[Index]} value={ddolist[Index]?.find((option) => option.ddocode === formik.values.list[Index].ddo_code) || ""} onChange={(option) => { MandalOrgData(option ? option.ddocode : "",Index); formik.setFieldValue(`list.[${Index}].ddo_code`,option ? option.ddocode : "") }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }} /> <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="ddo_code" /> </span> </Col>
            
                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" > <label className="mb-1 fw-bold"> ORGANIZATION NAME </label> <span style={{ color: "red" }}> *</span> <Select className="w-100" isClearable={true} isSearchable={true} name={`list.[${Index}].org_id`} required={true} getOptionValue={(option) => option.org_id} getOptionLabel={(option) => option.org_name} options={orglist[Index]} value={orglist[Index]?.find((option) => option.org_id === formik.values.list[Index].org_id) || ""} onChange={(option) => { EmployeeDetails(option ? option.org_id : "",Index); formik.setFieldValue(`list.[${Index}].org_id`,option ? option.org_id : "") }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }} /> </Col>
                                  <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" > <label className="mb-1 fw-bold"> EMPLOYEE NAME </label> <span style={{ color: "red" }}> *</span> <Select className="w-100" isClearable={true} isSearchable={true} name={`list.[${Index}].emp_id`} required={true} getOptionValue={(option) => option.cfms_id} getOptionLabel={(option) => option.emp_name} options={emplist[Index]} value={emplist[Index]?.find((option) => option.cfms_id === formik.values.list[Index].emp_id) || ""} onChange={(option) => { getEmployeeMapdata(formik.values.list[Index].org_id,option ? option.cfms_id : "", Index); formik.setFieldValue(`list.[${Index}].emp_id`,option ? option.cfms_id : "") }} isDisabled={false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }} /> </Col>
                                     <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" > <label className="mb-1 fw-bold"> ALTERNATE MOBILE </label> <span style={{ color: "red" }}> *</span> <Field type="text" name={`list.[${Index}].alternate_mobile_no`} className="form-control" onBlur={(e) => {validateMobileNumber(e.target.value);formik.handleChange(e)} } maxLength="10" onKeyPress={(e) =>{allowNumbersOnly(e)}} /></Col>
                              <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="org_id" /> </span>
                                         <div className="bottom-buttons justify-content-center d-flex  mb-1"> <Button variant="" size="sm" className="save-btn me-4"  type="button" onClick={()=>{SaveData(empmaplist[Index],formik.values.list[Index].alternate_mobile_no,Index,EditEmpdata.dist_id)}} > Update <FaRegSave className="ms-1 s-icon" /> </Button></div>                   
                                                         
                        
                                                        </Row>
                                                        </>}
                                                        </Form> </FormikProvider> <Row className="text-start mt-3 mx-1"> </Row> </Modal.Body> </Modal>
          </Form>
      </FormikProvider>

     <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    
    </DESUI.Container >
  </>
);
};



